import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from '@mui/material'
import React, { forwardRef, useEffect, useState } from 'react'

interface RadioItem {
  value: string
  label: string | React.ReactNode
  children?: React.ReactNode
}

interface RadioButtonGroupProps {
  defaultValue?: string
  disabled?: boolean
  error?: any
  helperText?: string
  items?: RadioItem[]
  label?: string | React.ReactElement
  value?: string
  name?: string
  split?: boolean
  onChange?(value: string | undefined): void
  id?: string
}

const RadioButtonGroup = forwardRef<any, RadioButtonGroupProps>(
  (
    {
      defaultValue,
      disabled,
      error,
      helperText,
      id,
      items,
      label,
      name,
      onChange,
      value: propValue,
      split
    },
    ref
  ) => {
    const [value, setValue] = useState(propValue || defaultValue)
    useEffect(() => {
      setValue(propValue)
    }, [propValue])

    const handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void = ({ target }) => {
      const { value: newValue } = target
      setValue(newValue)
      if (onChange) onChange(newValue)
    }

    return (
      <FormControl component="fieldset" disabled={disabled}>
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup id={id} aria-label={name} ref={ref} value={value} onChange={handleChange}>
          {split ? (
            <Grid container spacing={2}>
              {items?.map(item => (
                <Grid size={{ xs: 12, sm: 6 }} key={item.label?.toString()}>
                  <FormControlLabel
                    key={item.label?.toString()}
                    {...item}
                    control={
                      <Radio
                        sx={{
                          color: 'primary.main',
                          '&.Mui-checked': {
                            color: 'petrol'
                          },
                          '&.Mui-disabled': {
                            color: 'grey.300'
                          }
                        }}
                      />
                    }
                  />
                  {item.value === value && item.children ? <div>{item.children}</div> : null}
                </Grid>
              ))}
            </Grid>
          ) : (
            items?.map(item => (
              <div key={item.label?.toString()}>
                <div>
                  <FormControlLabel
                    key={item.label?.toString()}
                    {...item}
                    control={
                      <Radio
                        sx={{
                          color: 'primary.main',
                          '&.Mui-checked': {
                            color: 'petrol'
                          },
                          '&.Mui-disabled': {
                            color: 'grey.300'
                          }
                        }}
                      />
                    }
                  />
                </div>
                {item.value === value && item.children ? <div>{item.children}</div> : null}
              </div>
            ))
          )}
        </RadioGroup>
        <FormHelperText error={!!error}>{helperText}</FormHelperText>
      </FormControl>
    )
  }
)

export default RadioButtonGroup
